import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const AccountPaginationWrapper = styled.div`
    ${media.mobileDevice`
    position: fixed;
    width: 100%;
    bottom: 0;
    margin: 0 auto;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
        width: 100% !important;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        width: 100%;
    }
    ${media.mobileDevice`
        display: none;
    `}
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        // background-color:#f5f5f5 !important;
        background-color:#ffff;
    `}
`;

export const HeaderTextContainer = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
    width: 89px;
    font-family: AvenirNextWorld Demi;
    text-align: left;
    padding: ${(props) => props.deskPadding && props.deskPadding};
    ${media.smalDevice`
    padding: ${(props) => props.ipadPadding && props.ipadPadding};
    `}
    ${media.mobileDevice`
    padding: ${(props) => props.mbPadding && props.mbPadding};
    `}
`;

export const ProductGuideListContainerHeader = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    ${media.mediumDevice`
    `}
    ${media.smalDevice`
    `}

    ${media.mobileDevice`
        display: block;
        margin: -4px 0 0 0;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        
        padding-top: 20px;
        padding-right: 16px;
        padding-left: 16px;
        height: auto;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
    `}
`;

export const ProductGuideListContainer = styled.div``;

export const HeaderContainer = styled(Grid)`
    padding: 15px 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 2px;
    //margin-bottom: 10px;
    ${media.mobileDevice`
     display:none !important;
        `}
`;

export const SearchBoxContainer = styled.div`
    ${media.mobileDevice`
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 10px;
    `};
        .p-input-icon-right > i:last-of-type,
        .p-input-icon-right > svg:last-of-type,
        .p-input-icon-right > .p-input-suffix {
            right: 6% !important;
            left: 20rem;
        }
    }
    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        left: 19rem;        
        }
    }
`;
export const PaginationContainer = styled.div`
    height: 48px;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;

export const AccountGridContainer = styled(Grid)`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 10px;
`;
export const AccountNameGrid = styled(Grid)`
    text-align: left;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    letter-spacing: -0.12px;
    color: #1010eb;
    padding: 30px 21px;
    ${media.smalDevice`    
        padding:23px 23px;
        justify-content: space-between;
    `}
    ${media.mobileDevice`    
        padding-bottom:0px;
        position:relative;
    `}
`;
export const AccountNumberDesktopGrid = styled(Grid)`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 15px;
    letter-spacing: -0.12px;
    color: #140f4b;
    padding: 30px -1px;
`;
export const CityGrid = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    letter-spacing: -0.1px;
    color: #140f4b;
    text-transform: uppercase;
    opacity: 0.6;
    padding: 30px -1px;
`;

export const DistrictGrid = styled(Grid)`
    padding: 27px 30px;
    ${media.smalDevice`    
        padding: 25px 16px;
    `}
    ${media.mobileDevice`    
        padding:0px 25px !important;
        margin-bottom: 12px !important;
    `}
`;

export const DitrictNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
`;
export const TerritoryNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
`;
export const MoreContainer = styled.p`
    font-family: AvenirNextWorld Regular;
    font-size: 11px;
    letter-spacing: -0.09px;
    color: #1010eb;
    text-align: left;
`;

export const MainWrapper = styled.div`
    height: calc(100vh - 29rem);
    overflow-y: scroll;

    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 30px;
    }

    ${media.mediumDevice`
    
    `}

    ${media.smalDevice`
    height: calc(100vh - 27rem);
    padding: 0 0 15px 0;
    flex-direction: column;
`}

${media.mobileDevice`
    display: block;
    height: calc(100vh - 25rem);
    padding: 2px 16px 170px 16px;
    border-bottom-left-radius: ${(props) => (props.filterCount ? 0 : '0px')};
    border-bottom-right-radius: ${(props) => (props.filterCount ? 0 : '0px')};

`}
`;
